/**
 * Notification sound served from public/ (copied to build/ at the same path).
 * Service worker (firebase-messaging-sw.js) uses the same URL — keep both in sync.
 */
export const NOTIFICATION_SOUND_URL = "/Assets/Notification/different_old_phone7.mp3";
